import { render, staticRenderFns } from "./Budian.vue?vue&type=template&id=1804306d&scoped=true"
import script from "./Budian.vue?vue&type=script&lang=js"
export * from "./Budian.vue?vue&type=script&lang=js"
import style0 from "./Budian.vue?vue&type=style&index=0&id=1804306d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1804306d",
  null
  
)

export default component.exports